import { Box, Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./quotaModificationApprovalSlice";

export default function DisplayRecordsCheckbox() {
   const dispatch = useDispatch();
   const states = useSelector((store) => store.quotaModification);
   const { displayModifiedRecords } = states;

   function handleChange() {
      dispatch(setState("displayModifiedRecords", !displayModifiedRecords));
   }

   return (
      <Box sx={{ mt: 2 }}>
         <FormControlLabel
            control={<Checkbox checked={displayModifiedRecords} onChange={handleChange}  />}
            label="Display Modified Records"
         />
      </Box>
   );
}
